import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaBuilding } from "react-icons/fa";
import styled from "styled-components";

interface FilialOption {
    valor: string;
    label: string;
}

interface ModalSelecionarFilialProps {
    show: boolean;
    filiais: FilialOption[];
    qtdRegistros: number;
    onConfirm: (idFilial: string) => void;
    onCancel: () => void;
}

const FilialList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 300px;
    overflow-y: auto;
    padding: 8px 0;
`;

const FilialItem = styled.button<{ selected: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border: 2px solid ${props => props.selected ? '#1F467E' : '#e0e0e0'};
    border-radius: 8px;
    background: ${props => props.selected ? '#f0f4fa' : '#fff'};
    cursor: pointer;
    transition: all 0.15s;
    text-align: left;

    &:hover {
        border-color: #1F467E;
        background: #f8fafc;
    }

    .filial-nome {
        font-weight: ${props => props.selected ? '600' : '500'};
        font-size: 0.95rem;
        color: ${props => props.selected ? '#1F467E' : '#333'};
    }
`;

export default function ModalSelecionarFilial({ show, filiais, qtdRegistros, onConfirm, onCancel }: ModalSelecionarFilialProps) {
    const [filialEscolhida, setFilialEscolhida] = useState<string | null>(null);

    const handleConfirm = () => {
        if (filialEscolhida) {
            onConfirm(filialEscolhida);
            setFilialEscolhida(null);
        }
    };

    const handleClose = () => {
        setFilialEscolhida(null);
        onCancel();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FaBuilding color="#1F467E" />
                    Associar {qtdRegistros} registro(s) à unidade
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ color: '#666', marginBottom: 12 }}>Selecione a unidade destino:</p>
                <FilialList>
                    {filiais.map(f => (
                        <FilialItem
                            key={f.valor}
                            selected={filialEscolhida === f.valor}
                            onClick={() => setFilialEscolhida(f.valor)}
                        >
                            <FaBuilding size={16} color={filialEscolhida === f.valor ? '#1F467E' : '#999'} />
                            <span className="filial-nome">{f.label}</span>
                        </FilialItem>
                    ))}
                </FilialList>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
                <Button
                    variant="primary"
                    disabled={!filialEscolhida}
                    onClick={handleConfirm}
                    style={{ background: '#1F467E', borderColor: '#1F467E' }}
                >
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
